import { useSelector } from 'react-redux';
import { getCurrentTagGroups, getSelectedGroup } from './segments.state';

export const useSegments = () => {
    const selectedGroup = useSelector(getSelectedGroup);
    const tagGroups = useSelector(getCurrentTagGroups);

    return {
        selectedGroup,
        tagGroups,
    };
};
